// extracted by css-extract-rspack-plugin
export default {"headerRow":"SavedViews-module__headerRow__TMNUF","collapsedDivider":"SavedViews-module__collapsedDivider__GE6zK","savedViewsList":"SavedViews-module__savedViewsList__jQW4m"};